export class VendorSetupInternational {

    public CompanyName: string;
    public FeinNumber: string;
    public ContactPerson: string;
    public ContactEmail:string;
    public ContactPhone: string;
    public ContactFax: string;
    public ContactAddress1: string;
    public ContactAddress2: string;
    public ContactCity: string;
    public ContactState: string;
    public ContactZip: string;
    public ContactCountry: string;
    public ContactCurrency: string;
    public ContractNumber: string;
    public PaymentTerms: string;
    public AccountName: string;
    public BankName: string;
    public BankAddress1: string;
    public BankAddress2: string;
    public BankCity: string;
    public BankState: string;
    public BankZip: string;
    public BankCountry: string;
    public AccountType: string;
    public AccountNumber: string;
    public RoutingCodeNumber:string;
    public RoutingCodeType:string;
    public SwiftCode: string;
    public IntermediaryBank: string;
    public IntermediaryRoutingNumber: string;
    public IntermediarySwiftCode: string;
    public IntermediaryAccountNumber: string;
    public IntermediaryAddress1: string;
    public IntermediaryAddress2: string;
    public IntermediaryCity: string;
    public IntermediaryState: string;
    public IntermediaryZip: string;
    public IntermediaryCountry: string;
    public Organizer:string
    public OrganizerDate:string;
    public AcctVendorNumber:string;
    public DateAdded:string;
    public CreatedBy:string;
    public IsCustomer:string;
    public FileName: string;
    public FileBytesBase64: string;
    public RemitToContactPerson: string;
    public RemitToContactEmail: string;
    public VendorNeededIn: string;
}



// WEBPACK FOOTER //
// ./src/app/models/VendorSetupInternational.ts